"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.propertyProviderTab = propertyProviderTab;

var _eventsObject = require("./eventsObject");

var ObjectEvents = _interopRequireWildcard(_eventsObject);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {AppEventEmitter}  outgoingDispatcher
 * @param {ContextProps} contextProps
 * @return {Function}
 */
function propertyProviderTab(outgoingDispatcher, contextProps) {
  var tabId = contextProps.tabId;


  if (!tabId) {
    throw new Error('context is missing the tab id');
  }

  return function (props) {
    var eventProps = (0, _extends3.default)({}, props, { tabId: tabId });
    return outgoingDispatcher.emitAsync(ObjectEvents.EVENT_CONTEXT_PROPERTY_GET, eventProps);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Context/properties.js
// module id = 326
// module chunks = 0